/*
 * Copyright (c) Orion Developments Ltd and the Orion Health group of companies (2001 - 2021).
 *
 * This document is subject to copyright. Except as permitted by copyright law
 * applicable to you, no part of this publication may be reproduced or
 * transmitted in any form or by any means, electronic or mechanical, including
 * photocopying, recording, downloading, or any information storage and
 * retrieval system, without permission in writing from Orion Developments
 * Limited. Infringers of copyright render themselves liable for prosecution.
 */

import './App.css';
import RolesBrowser from './RolesBrowser'
import { AuthenticationProvider, oidcLog, OidcSecure } from '@axa-fr/react-oidc-context';
import { BrowserRouter as Router } from 'react-router-dom';
import { UserManagerSettings } from 'oidc-client';
import DisplayError from './DisplayError'
import DisplayLoading from './DisplayLoading'

function App(): JSX.Element {

  const config: UserManagerSettings = {
    client_id: process.env.REACT_APP_CLIENT_ID,
    redirect_uri: process.env.REACT_APP_MAIN_URL + '/authentication/callback',
    response_type: 'code',
    post_logout_redirect_uri: process.env.REACT_APP_MAIN_URL,
    scope: 'openid profile',
    authority: 'https://orionhealth.onelogin.com/oidc/2',
    // silent_redirect_uri seems unused since OneLogin has a refresh token
    // and this field is marked as optional, but not providing it breaks the @axa-fr/react-oidc-context library
    silent_redirect_uri: process.env.REACT_APP_MAIN_URL + '/authentication/silent_callback',
    automaticSilentRenew: true,
    loadUserInfo: true,
  };

  return (
    <div>
      <Router>
        <AuthenticationProvider
          configuration={config}
          loggerLevel={process.env.NODE_ENV === 'development' ? oidcLog.DEBUG : oidcLog.INFO}
          isEnabled={true}
          authenticating={() => <div>Authenticating...</div>}
          notAuthenticated={DisplayError}
          notAuthorized={DisplayError}
          callbackComponentOverride={DisplayLoading}
          sessionLostComponent={() => <div>Session Lost...</div>}
        >
          <OidcSecure>
            <RolesBrowser />
          </OidcSecure>
        </AuthenticationProvider>
      </Router>
    </div>

  )
}

export default App;
